(() => {
  if (window.glSizeDialogBound) return;
  window.glSizeDialogBound = true;
  let opener;
  let previousOverflow;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gl-size-open]');
    const dialog = document.getElementById('GlSizeDialog');
    if (!dialog) return;
    if (trigger) {
      opener = trigger;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.querySelector('.gl-size-dialog__body').scrollTop = 0;
      dialog.querySelector('[data-gl-size-close]').focus({ preventScroll: true });
    } else if (event.target.closest('[data-gl-size-close]') || event.target === dialog) {
      dialog.close();
    }
  });
  document.getElementById('GlSizeDialog')?.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow ?? '';
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
})();
